import Vue from 'vue';
import Component from 'vue-class-component';
import { decodeUrl } from '../utils/url-encode-decode';
import { ConstructionStoreActions } from '../store/ConstructionTypes';
import { Action } from 'vuex-class';
import { Construction } from '@/app/domain/constructionStoreInterface';
import { languageOfCorrespondenceToString } from '@/app/utils/language-utils';

@Component
export default class DataUrlMixin extends Vue {

    @Action(ConstructionStoreActions.SaveConstruction)
    private saveConstructionForDataURL!: (construction: Construction) => void;

    public parseDataFromUrl() {
        if (this.$route.query.data) {
            const urlParam: string = this.$route.query.data as string;
            const construction = decodeUrl(urlParam);
            this.saveConstructionForDataURL(construction);
            const query = Object.assign({}, {
                data: this.$route.query.data,
            });
            if (construction
                && construction.principalLiability
            ) {
                Object.assign(query, {
                    ...query,
                    lang: languageOfCorrespondenceToString(construction.principalLiability.languageOfCorrespondence),
                });
            }
            this.$router.replace({ query });
        }
    }

}
